import { MASK_PROCESSO_SEI } from './mask';

const MAX_DIGITS = MASK_PROCESSO_SEI.filter(
  token => token instanceof RegExp
).length;

export const formatProcessoSei = (processo?: string): string => {
  if (typeof processo !== 'string') {
    return processo || '';
  }

  const onlyDigits = processo.replace(/\D/g, '').slice(0, MAX_DIGITS);

  if (!onlyDigits) {
    return '';
  }

  let formatted = '';
  let digitIndex = 0;

  for (const token of MASK_PROCESSO_SEI) {
    if (digitIndex >= onlyDigits.length) {
      break;
    }

    if (typeof token === 'string') {
      formatted += token;
      continue;
    }

    formatted += onlyDigits.charAt(digitIndex);
    digitIndex += 1;
  }

  return formatted;
};
